var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401 404.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-6,.cls-7,.cls-8{fill:none;}.cls-1,.cls-2{stroke:#052941;}.cls-1,.cls-10,.cls-2,.cls-6,.cls-7,.cls-8{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{fill:#fff;}.cls-3{fill:#500089;}.cls-4{fill:#f29f02;}.cls-5{fill:#052941;}.cls-6{stroke:#fff;}.cls-10,.cls-7,.cls-8{stroke:#2660f6;}.cls-8{stroke-dasharray:12.652 12.652;}.cls-9{fill:#06d1c2;}.cls-10{opacity:0.2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no_chats",
    "data-name": "no chats"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.914,223.136a8.638,8.638,0,0,1-4.809-3.95,60.965,60.965,0,0,0-6.149-8.709,1.117,1.117,0,0,1,.688-1.839,4.663,4.663,0,0,1,2.82.617,13.567,13.567,0,0,1,3.776,3.5c4.8,5.83,13.241,6.961,20.7,5.805,1.853-.287,3.679-.78,5.551-.892a7.836,7.836,0,0,1,5.33,1.365c-.566,1.93-2.813,3.18-4.662,3.971-3.294,1.41-6.779,2.716-10.354,2.475a24.892,24.892,0,0,1-3.36-.537C71.264,224.283,68.01,224.114,64.914,223.136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.507,219.1c-1.385-2.877-4.79-4.074-7.883-4.869a9.046,9.046,0,0,1-2.642-.972,27.932,27.932,0,0,1-2.8-2.669c-.984-.838-2.518-1.333-3.536-.538a2.472,2.472,0,0,0-.785,2.255,6.935,6.935,0,0,0,.875,2.324c.628,1.193,2.632,3.162,3.979,3.11C91.134,220.482,94.482,220.442,99.507,219.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.475,220.026s11.123,2.812,12.39,2.056a22.6,22.6,0,0,0,3.163-2.986,6.357,6.357,0,0,1,4.6-2.01c13.34-.092,11.236,5.884,11.273,10.13a23.147,23.147,0,0,0,.438,3.806c1.908,3.229,5.851,9.958,5.851,9.958-4.051,1.913-8.012,4.38-12.289,5.714-2.01-3.323-2.263-7.869-4.273-11.191h0a26.919,26.919,0,0,0-5.828-3.32c-7.934-3.512-18.424-6.7-20.7-8.351-1.792-1.3-4.623-8.015-5.741-10.8a1.271,1.271,0,0,1,1.147-1.747C65.816,211.212,71.475,220.026,71.475,220.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M185.5,211.675s-7.035-8.215-19.9-4.737c-19.037,5.145-29.421,65.461-31.584,75.242s2.915,41.222,10.384,41.161c7.045-.057,18.945-16.909,25.094-51.35C174.348,244.776,185.5,211.675,185.5,211.675Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.313,248.038s13.412-7.5,19.9-7.9l26.392,47.765,7.788,34.739s-16.009,5.527-27.041-14.606S90.313,248.038,90.313,248.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M221.349,212.047a22.454,22.454,0,0,1,21.2-5.114c19.037,5.113,29.421,65.063,31.584,74.784s-2.915,40.972-10.384,40.912c-7.045-.057-18.945-16.806-25.094-51.038C233.793,244.541,221.349,212.047,221.349,212.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.522,221.814a8.639,8.639,0,0,0,4.808-3.95,60.948,60.948,0,0,1,6.15-8.709,1.118,1.118,0,0,0-.689-1.839,4.666,4.666,0,0,0-2.819.618,13.525,13.525,0,0,0-3.776,3.5c-4.8,5.83-13.241,6.96-20.7,5.805-1.854-.287-3.68-.781-5.552-.892a7.821,7.821,0,0,0-5.329,1.365c.565,1.93,2.813,3.179,4.662,3.971,3.294,1.41,6.778,2.715,10.353,2.475a24.687,24.687,0,0,0,3.36-.538C336.171,222.962,339.425,222.793,342.522,221.814Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.928,217.775c1.385-2.878,4.79-4.074,7.883-4.87a9.036,9.036,0,0,0,2.642-.972,28.044,28.044,0,0,0,2.8-2.668c.984-.838,2.517-1.334,3.536-.538a2.473,2.473,0,0,1,.785,2.255,6.954,6.954,0,0,1-.876,2.324c-.628,1.192-2.632,3.162-3.979,3.11C316.3,219.16,312.954,219.12,307.928,217.775Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.96,218.705s-11.123,2.811-12.39,2.055a22.485,22.485,0,0,1-3.162-2.986,6.359,6.359,0,0,0-4.6-2.009c-13.339-.092-11.236,5.883-11.272,10.129a23.255,23.255,0,0,1-.439,3.806c-1.908,3.229-5.851,9.958-5.851,9.958,4.051,1.914,8.012,4.381,12.289,5.714,2.011-3.322,2.263-7.868,4.273-11.191h0a26.949,26.949,0,0,1,5.829-3.32c7.934-3.511,18.423-6.7,20.695-8.351,1.792-1.3,4.624-8.015,5.741-10.8a1.271,1.271,0,0,0-1.146-1.747C341.619,209.891,335.96,218.705,335.96,218.705Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.828,246.072s-13.412-7.7-19.9-8.1l-26.392,49.013-7.788,35.646s16.009,5.671,27.041-14.988S317.828,246.072,317.828,246.072Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "170.776 211.129 162.25 323.341 248.638 323.341 235.212 216.323 219.927 211.129 207.671 213.005 170.776 211.129"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.506,
    y1: 322.629,
    x2: 297.13,
    y2: 323.341
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.497 212.02 204.872 322.629 221.349 215.481 185.497 212.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.237,195.4,185.5,212.02s3.735,12.6,18.517,12.6,17.335-9.138,17.335-9.138l-1.124-20.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.241,163.144a4.684,4.684,0,0,0-8.422.309c-1.01,2.291.006,5.07,1.781,6.836a18.835,18.835,0,0,0,6.49,3.677c.659.264,1.5.5,2-.011a1.764,1.764,0,0,0,.385-1.022,24.08,24.08,0,0,0-.328-8.555C181.058,163.967,179.438,163.515,179.241,163.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.4,177.563a12.159,12.159,0,0,0,6.191-4.927c1.1-1.745,1.732-4.033.771-5.862s-4-2.405-5.06-.635C228.334,170.159,227.194,173.623,226.4,177.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.281,174.731s3.442,29.928,23.868,29.928,26.411-21.947,25.613-49.082c0,0,.468-16.361-24.706-17.558S178.882,159.568,179.281,174.731Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.255,161.565c.151,1.071-.038,2.169.132,3.236a2.544,2.544,0,0,0,1.948,2.3c1.579.156,2.434-1.775,2.764-3.328a92.029,92.029,0,0,0,2.291-15.611c6.176.483,12.213-1.381,18.037-4.932,1.008,1.26,27.547,14.844,28.823-3.438.326-4.666-4.419-16.982-22.581-9.12-2.486-4.281-8.6-5.479-13.29-3.9s-8.219,5.623-10.347,10.093c-10.965-.089-15.41,16.715-12.1,23.8C176.2,163.369,178.493,161.4,179.255,161.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.984,146.777a14.691,14.691,0,0,1-1.158,19.644c.569-5.1-.365-11.187-1.58-16.174a4.094,4.094,0,0,1-.178-1.765C227.375,146.958,228.454,147.052,229.984,146.777Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "210.913 162.331 210.913 177.004 207.599 177.004"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 195.478,
    cy: 165.923,
    rx: 1.578,
    ry: 3.035
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 219.925,
    cy: 165.923,
    rx: 1.578,
    ry: 3.035
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.615,157.7a5.352,5.352,0,0,0,4.348,3.518"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.543,153.823a6.42,6.42,0,0,0-6.129,3.294"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.332,178.833c1.629,3.535,4.832,5.176,8.146,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.551,176.664a15.517,15.517,0,0,1-2.82,3.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 162.25,
    y1: 307.194,
    x2: 165.41,
    y2: 278.018
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 247.266,
    y1: 307.194,
    x2: 244.105,
    y2: 278.018
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "182.515 218.67 173.861 237.97 185.497 255.064 181.714 267.324 196.551 317.353"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "224.801 218.67 233.456 237.97 221.82 255.064 225.602 267.324 210.766 317.353"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.61,244.076q6.4,3.436,12.434,7.493"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.325,247.171l-12.533,5.357"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "127.509 169.374 133.509 169.374 129.266 165.131"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M125.029,154.234V143.41a6.085,6.085,0,0,0-6.085-6.085H89.633a6.085,6.085,0,0,0-6.085,6.085v19.879a6.085,6.085,0,0,0,6.085,6.085h31.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.234,114.834v31.357l-14.791,14.791h79.17A11.691,11.691,0,0,0,357.3,149.291V114.834a11.691,11.691,0,0,0-11.691-11.691H292.925A11.691,11.691,0,0,0,281.234,114.834Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 319.269,
    cy: 132.062,
    r: 17.932
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 298.924,
    y1: 111.718,
    x2: 339.614,
    y2: 152.407
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M147.679,108.523a7.282,7.282,0,0,1,9.554-3.3c2.452,1.26,4.339,4.008,7.095,3.959,3.139-.055,5.125-3.75,8.218-4.287,2.474-.429,4.744,1.263,6.885,2.577s5.123,2.24,6.984.554"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 139.609,
    cy: 199.177,
    r: 2.793
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 280.459,
    cy: 199.551,
    r: 6.529
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 293.959,
    cy: 205.141,
    r: 3.172
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M59.085,307.135c-.14-3.868,3.41-7.155,7.228-7.789s7.7.827,11,2.842,6.336,4.638,10.059,5.692a13.36,13.36,0,0,0,13.732-4.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.774ad023.svg";
export { ForwardRef as ReactComponent };